module.exports = __webpack_public_path__ + "img/_canonical_.63ae6467.svg";